import axios from '@/zenky'

export default async function deleteAddress(id) {
  return axios.delete(`/profile/addresses/${id}`);
}
